export const MASKED_TEXT_FIELD_DATA_IDS = {
  base: 'masked',
  container: 'container',
  labelTooltip: 'label',
  label: 'label',
  textField: '',
  adornment: 'adornment',
  clearBtn: 'clear'
};
